export const isRelativeDateValue = (value) => typeof value === "object" && value !== null && "kind" in value &&
    value.kind === "relative-date" && "preset" in value &&
    ["today", "yesterday", "thisWeek", "thisMonth", "last7Days", "last30Days"].includes(String(value.preset)) &&
    "timeZone" in value && typeof value.timeZone === "string" &&
    (() => { try {
        new Intl.DateTimeFormat("en-US", { timeZone: value.timeZone });
        return true;
    }
    catch {
        return false;
    } })();
const civilDate = (date, timeZone) => {
    const parts = new Intl.DateTimeFormat("en-CA", {
        timeZone, year: "numeric", month: "2-digit", day: "2-digit",
    }).formatToParts(date);
    const value = (type) => parts.find((part) => part.type === type)?.value ?? "";
    return [value("year"), value("month"), value("day")].join("-");
};
const addDays = (date, days) => {
    const result = new Date(`${date}T12:00:00Z`);
    result.setUTCDate(result.getUTCDate() + days);
    return result.toISOString().slice(0, 10);
};
export const resolveRelativeDateRange = (value, now) => {
    const date = civilDate(now, value.timeZone);
    const year = Number(date.slice(0, 4));
    const month = Number(date.slice(5, 7));
    const weekday = new Date(`${date}T12:00:00Z`).getUTCDay();
    switch (value.preset) {
        case "today": return [date, date];
        case "yesterday": return [addDays(date, -1), addDays(date, -1)];
        case "last7Days": return [addDays(date, -6), date];
        case "last30Days": return [addDays(date, -29), date];
        case "thisWeek": return [addDays(date, -(weekday === 0 ? 6 : weekday - 1)), date];
        case "thisMonth": return [`${year}-${String(month).padStart(2, "0")}-01`, date];
    }
};
//# sourceMappingURL=filter-relative.js.map